import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap, catchError, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { appsettings } from '../settings/appsettings';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class InicioService {

  private http = inject(HttpClient);
  private url = appsettings.apiUrl;
  private rutas = inject(Router)


  private userSubject = new BehaviorSubject<any | null>(null);
  public user$: Observable<boolean> = this.userSubject.asObservable();

  updateLogeo(user: any){
    this.userSubject.next(user);
  }

  validaToken(token: string):Observable<any>{
    return this.http.get<any>(`${this.url}/usuarios/valida_token/${token}`)
  }

  login(objeto: any):Observable<any>{
    return this.http.post<any>(`${this.url}/usuarios/login`, objeto).pipe(
      tap((rs) => {
        if(!rs.data){
          false
        }
        else{
          localStorage.setItem('usuSesion', JSON.stringify(rs.data));
          localStorage.setItem("token", rs.token);
          this.userSubject.next(rs.data);
        }
      })
    );
  }

  cerrarSesion(id_institucional: number): Observable<any> {
    return this.http.get<any>(`${this.url}/usuarios/cerrar_sesion/${id_institucional}`)
      .pipe(
        tap(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('usuSesion');
          //localStorage.clear();
          this.userSubject.next(null);
        })
      );
  }

  listarMotores(): Observable<any> {
    const url = `${this.url}/usuarios/listar_motores`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarOcupaciones(id_motor_productivo: string): Observable<any> {
    const url = `${this.url}/usuarios/listar_ocupaciones/${id_motor_productivo}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarPerfiles(id_motor_productivo: string, id_perfil_productivo: string): Observable<any> {
    const url = `${this.url}/usuarios/listar_perfiles/${id_motor_productivo}/${id_perfil_productivo}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

}
